import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
// MUI
import { CircularProgress, Grid2 } from "@mui/material";
// Icons
import PhpOutlinedIcon from "@mui/icons-material/PhpOutlined";
import { ReactComponent as BlueprintSite } from "../../../../../../GlobalAssets/svg/Blueprint12.svg";
import { ReactComponent as Production } from "../../../../../../GlobalAssets/svg/Production.svg";
import { ReactComponent as WordPress } from "../../../../../../GlobalAssets/svg/Wordpress.svg";
import { ReactComponent as Delete } from "../../../../../../GlobalAssets/svg/Delete.svg";
import { ReactComponent as BluePrint } from "../../../../../../GlobalAssets/svg/BluePrint.svg";
import { ReactComponent as PerformanceIcon } from "../../../../AdminAssets/svg/performance.svg";
import { ReactComponent as WafIcon } from "../../../../AdminAssets/svg/WafIcon.svg";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import DrawIcon from "@mui/icons-material/Draw";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import CodeIcon from "@mui/icons-material/Code";
// Styling
import styles from "./Header.module.scss";
// Local import
import IconButton from "../../../../../../GlobalComponents/IconButton/IconButton";
import EnvironmentBox from "../../../../../../GlobalComponents/EnvironmentBox/EnvironmentBox";
import FormPopup from "../../../../../../GlobalComponents/FormPopup/FormPopup";
import { Actions } from "../../../../../../redux/constants/actionTypes";
import { getStore } from "../../../../../../Utils/storeUtils";
import { useMakeApiCalls } from "../../../../../../Hooks/useMakeApiCalls";
import { useLocation, useNavigate } from "react-router-dom";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import EditSiteImage from "./SubPages/EditSiteImage";
import NewPopup from "../../../../../../GlobalComponents/Popup/NewPopup";
import CustomInput from "../../../../../../GlobalComponents/CustomInput/CustomInput";
import { buildsV1Sites, verifyPassword } from "../../../../../../Utils/roconConstants";
import BuyStaging from "../../../CreateSite/Components/BuyStaging/BuyStaging";
import Environment from "../../../../../../GlobalComponents/Environment/Environment";
import { cashfreeSubscriptionSessionIdDecrypt } from "../../../../../../Utils/cashfree";
import { getRoleInOrg } from "../../../../../../Utils/organizations";
import AddonIcons from "../../../../../../GlobalComponents/AddonIcons/AddonIcons";
import {
  millisecondsToRoundedHours,
  useEmailId,
} from "../../../../../../Utils/utils";
import CredentialsDropdown from "../../../../../../GlobalComponents/CredentialsDropdown/CredentialsDropdown";
import { reachedMaximum } from "../../../CreateSite/Components/ConstantData/CreateSiteConstantData";

export default function SiteHeaderCard(props) {
  const {
    name,
    domain,
    development,
    production,
    domainClick,
    siteId,
    orgId,
    image,
    selectedCountry,
    orgInfo,
    addOnWaf,
    addOnPerformanceSite,
  } = props;

  const navigate = useNavigate();
  const location = useLocation();
  const [popupCard, setPopupCard] = useState("");
  const [loading, setLoading] = useState(false);
  const [isStaging, setIsStaging] = useState(false);
  const [addStaging, setAddStaging] = useState(false);
  const [stageType, setIsStageType] = useState("clone-prod");
  // const [isExpired, setIsExpired] = useState(false);
  const [quantity, setQuantity] = useState(0);
  const [isChecked, setIsChecked] = useState(false);
  const [isToggle, setIsToggle] = useState(development ? true : false);
  const [isLoading, setIsLoading] = useState(false);
  const [nameLoading, setNameLoading] = useState(false);
  const [nameValid, setNameValid] = useState(true);
  const [submit, setSubmit] = useState(false);
  const [credentials, setCredentials] = useState({
    username: "",
    password: "",
  });
  const [isInput, setIsInput] = useState({
    tempdomainname: "",
    tempdomainnamedev: "",
    tempdomainsuffix: `.${process.env.REACT_APP_TEMP_DOMAIN}`,
    tempdomainnamedeverror: false,
    tempdomainnamedevErrorMessage: "Temporary domain already exists!",
    wordpresspassworddev: "",
    wordpresspassworddeverror: false,
    wordpressusernamedev: "",
    wordpressusernamedeverror: false,
    wordpressconfirmpassworddev: "",
    wordpressconfirmpassworddeverror: false,
    wordpresspassworderror: false,
    wordpresspasswordErrorMessage:
      "Requires at least 8 characters with one capital letter, one numeric character, and one special character",
    waf: true,
    sameDomainName: "Temporary domain name cannot be the same as the site name",
  });

  const maxLength = 25;
  const minLength = 3;
  const emailId = useEmailId();
  const [popup, setPopup] = useState({
    popupState: false,
    popupType: "",
    popupTitle: "",
    popupSubtitle: "",
    popupSubtitle1: "",
    popupButton: false,
    popupCancel: false,
    popupButtonTitle: "",
    popupCancelTitle: "",
    popupButtonFunction: () => {},
    popupCancelFunction: () => {},
  });

  useMakeApiCalls(() => {
    getStore().dispatch({
      type: Actions.API_ALL_PLANS,
    });
    getStore().dispatch({
      type: Actions.API_GET_SEPCIFIC_PLAN,
      data: { orgId: orgId },
    });
  });

  useEffect(() => {
    if (name) {
      getStore().dispatch({
        type: Actions.API_SITES_LB_ARN,
        data: {
          siteName: name,
          siteId: siteId,
        },
      });
    }
  }, [name]);

  const statusLb = useSelector((state) => state.sitesInfo?.siteArns ?? {});

  const { stagingCredits, usedCreditsTs, status } = useSelector((state) => ({
    stagingCredits: state.sitesInfo?.credits?.stagingCredits,
    usedCreditsTs: state.sitesInfo?.credits?.usedTs,
    status: state.sitesInfo?.credits?.status,
  }));

  let usedCredits = millisecondsToRoundedHours(usedCreditsTs);

  // const stgEnv = useSelector((state) =>
  //   state.sitesInfo?.selectedSite?.stagingDomainsList?.find(
  //     (list) => list.environment === "STAGING"
  //   )
  // );

  const getSiteStatus = () => {
    return statusLb[siteId] === true ? "Available" : "Site Down";
  };

  const stagingplan = useSelector((state) =>
    state.plansInfo?.specificPlan?.specificPlans.find(
      (item) => item.licenseType === "Staging",
    ),
  );
  const limits = stagingplan?.featureDetails.find(
    (item) => item.type === "STAGING",
  )?.limitOrAvailablity;

  let plans = useSelector(
    (state) => state?.plansInfo?.allPlans?.features?.licenses,
  );

  let userDetails = useSelector((state) => state.users.userDetails?.theme);

  const specificPlan = useSelector(
    (state) => state.plansInfo?.specificPlan?.specificPlans,
  );

  const basePlan = specificPlan?.find((plan) => plan.basePlan === true);
  const isSingleSite = specificPlan?.find((plan) => plan.isSingleSite === true);

  const numSitesFeature = basePlan?.featureDetails?.find(
    (feature) => feature.type === "NUM_SITES",
  );

  const isLimitReached =
    numSitesFeature?.limitOrAvailablity === numSitesFeature?.used;

  let priceId = plans
    ?.find((plan) => plan?.licenseType === "Staging")
    ?.pricing.map((price) => price?.stripePriceId)[0];

  const organizationId = parseInt(orgId, 10);

  const selectedDomain = useSelector((state) => state.sitesInfo.selectedDomain);

  const siteDomain = useSelector(
    (state) => state.sitesInfo.selectedSite.stagingDomainsList,
  );

  const siteName = useSelector(
    (state) => state.sitesInfo.selectedSite.siteName,
  );

  const isDedicated = useSelector(
    (state) => state.sitesInfo?.selectedSite?.dedicatedInstanceDetails,
  );

  const instancePw = useSelector((state) => state.sitesInfo?.instancePassword);

  const dedicatedHosting = useSelector(
    (state) => state.plansInfo?.specificPlan?.isDedicated === true,
  );
  // EBS (v2) sites have no staging environment: hide the staging box, its hours
  // widget and the create flow, the same way dedicated hosting does
  const ebsSite = useSelector(
    (state) =>
      state.sitesInfo?.selectedSite?.ebsSite === true &&
      String(state.sitesInfo?.selectedSite?.siteId) === String(siteId),
  );

  const useEnvironment = () => {
    if (location.search.includes("staging")) {
      return "STAGING";
    } else if (location.search.includes("live")) {
      return "LIVE";
    } else {
      return "UNKNOWN";
    }
  };

  const environment = useEnvironment();

  const handleEnvClick = (label, env) => {
    const selectedEnvData = siteDomain.find(
      (list) => list.environment === (env || environment),
    );
    if (selectedEnvData) {
      getStore().dispatch({
        type: Actions.SET_SELECTED_DOMAIN,
        data: selectedEnvData,
      });
    }
  };

  useEffect(() => {
    if (environment !== "UNKNOWN") {
      handleEnvClick(
        environment === "STAGING" ? "Staging" : "Production",
        environment,
      );
    }
  }, [environment]);

  useEffect(() => {
    development != null && development != undefined
      ? setIsToggle(true)
      : setIsToggle(false);
  }, [development]);

  useEffect(() => {
    // the staging hours widget is not shown for EBS sites, so don't poll for it
    if (ebsSite) {
      return undefined;
    }
    const fetchData = () => {
      getStore().dispatch({
        type: Actions.API_STAGING_TIMESTAMP,
        data: {
          orgId: orgId,
          siteId: siteId,
        },
        meta: {
          onSuccess: () => {},
          onError: () => {},
        },
      });
    };

    fetchData();

    const intervalId = setInterval(fetchData, 600000);

    return () => clearInterval(intervalId);
  }, [orgId, ebsSite]);

  useEffect(() => {
    const fetchData = () => {
      getStore().dispatch({
        type: Actions.API_STAGING_DOMAIN_LIST,
        data: {
          siteId: siteId,
          toggle: isToggle,
        },
        meta: {
          onSuccess: () => {},
          onError: () => {},
        },
      });
    };

    fetchData();

    const intervalId = setInterval(fetchData, 600000);

    return () => clearInterval(intervalId);
  }, [orgId]);

  const handleStaging = () => {
    if (!isStaging) {
      setIsChecked(false);
    }
    setIsStaging(!isStaging);
  };

  const handleAddStaging = () => {
    setAddStaging(!addStaging);
  };

  const getBackgroundColor = () => {
    if (selectedDomain?.environment === "STAGING") {
      return userDetails === "dark" ? "#141618" : "#f0f3f8";
    } else {
      return userDetails === "dark" ? "#181a1c" : "#ffffff";
    }
  };

  const getBorderColor = () => {
    return "#135fc2";
  };

  const handleCloneSiteClick = () => {
    if (isLimitReached) {
      setPopup({
        popupState: true,
        popupType: "warning",
        popupTitle: `${reachedMaximum?.title} ${numSitesFeature?.used}/${numSitesFeature?.limitOrAvailablity}`,
        popupSubtitle: reachedMaximum?.subTitle,
        popupCancel: true,
        popupButton: true,
        popupButtonTitle: reachedMaximum?.button,
        popupButtonFunction: () => {
          setPopup({ popupState: false });
          navigate(`/account/${orgId}/modify-plan`);
        },
        popupCancelFunction: () => {
          setPopup({ popupState: false });
        },
        popupCancelTitle: "Cancel",
      });
    } else {
      navigate(`/account/${orgId}/create?cloneSiteId=${siteId}`);
    }
  };

  const ActivatePopup = (type) => {
    if (type === "error") {
      setPopup({
        popupState: true,
        popupType: "error",
        popupTitle: "Something Went Wrong",
        popupSubtitle: "An unexpected error occurred. Please try again.",
        popupCancel: false,
        popupButton: true,
        popupButtonTitle: "OK",
        popupButtonFunction: () => {
          setPopup({ popupState: false });
        },
      });
    } else if (type === "success") {
      setPopup({
        popupState: true,
        popupType: "success",
        popupTitle: "Hurray it's done!!",
        popupCancel: false,
        popupButton: true,
        popupButtonTitle: "OK",
        popupButtonFunction: () => {
          setPopup({ popupState: false });
          navigate(`/account/${orgId}/sites-overview`);
          window.location.reload();
        },
      });
    } else if (type === "success_staging") {
      setPopup({
        popupState: true,
        popupType: "success",
        popupTitle: "Hurray it's done!!",
        popupCancel: false,
        popupButton: true,
        popupButtonTitle: "OK",
        popupButtonFunction: () => {
          window.location.reload();
          setPopup({ popupState: false });
        },
      });
    } else if (type === "success-del-prod") {
      setPopup({
        popupState: true,
        popupType: "success",
        popupTitle: "Production Environment Deleted Successfully",
        popupSubtitle: "Your production environment was successfully deleted.",
        popupCancel: false,
        popupButton: true,
        popupButtonTitle: "OK",
        popupButtonFunction: () => {
          setPopup({ popupState: false });
          navigate(`/account/${orgId}/sites-overview`);
          window.location.reload();
        },
      });
    } else if (type === "delete") {
      setPopup({
        popupState: true,
        popupType: "warning",
        popupTitle: "Delete Site?",
        popupSubtitle:
          "Are you sure you want to delete this site? This action cannot be undone.",
        popupCancel: true,
        popupButton: true,
        popupButtonTitle: "Yes",
        popupCancelTitle: "No",
        popupCancelFunction: () => {
          setPopup({ popupState: false });
        },
        popupButtonFunction: () => {
          setLoading(true);
          getStore().dispatch({
            type: Actions.API_DELETE_SITE,
            data: {
              siteId: siteId,
            },
            meta: {
              onSuccess: () => {
                getStore().dispatch({
                  type: Actions.API_GET_USER_NOTIFICATIONS,
                });
                ActivatePopup("success-del-prod");
                setLoading(false);
              },
              onError: (error) => {
                const statusCode =
                  error?.response?.status ||
                  error?.status ||
                  error?.data?.response?.status;

                const isTimeout =
                  statusCode === 504 ||
                  error?.code === "ECONNABORTED" ||
                  error?.code === "ERR_NETWORK" ||
                  error?.message?.includes("timeout") ||
                  error?.message?.includes("Network Error");

                if (isTimeout) {
                  getStore().dispatch({
                    type: Actions.API_GET_USER_NOTIFICATIONS,
                  });
                  ActivatePopup("success-del-prod");
                  setLoading(false);
                  return;
                }

                setLoading(false);
                ActivatePopup("error");
              },
            },
          });
        },
      });
    } else if (type === "delete-staging") {
      setPopup({
        popupState: true,
        popupType: "warning",
        popupTitle: "Delete Staging Environment?",
        popupSubtitle:
          "This will permanently remove the staging environment. Are you sure you want to continue?",
        popupCancel: true,
        popupButton: true,
        popupButtonTitle: "Yes",
        popupCancelTitle: "No",
        popupCancelFunction: () => {
          setPopup({ popupState: false });
        },
        popupButtonFunction: () => {
          setLoading(true);
          handleDeleteStaging();
        },
      });
    } else if (type === "success-del-staging") {
      setPopup({
        popupState: true,
        popupType: "success",
        popupTitle: "Staging Environment Deleted Successfully",
        popupSubtitle: "Your staging environment was successfully deleted.",
        popupCancel: false,
        popupButton: true,
        popupButtonTitle: "OK",
        popupButtonFunction: () => {
          window.location.reload();
          setPopup({ popupState: false });
        },
      });
    } else if (type === "staging-created") {
      setPopup({
        popupState: true,
        popupType: "success",
        popupTitle: "Staging Environment Created Successfully",
        popupSubtitle:
          "Your new staging environment has been set up and is ready to use.",
        popupCancel: false,
        popupButton: true,
        popupButtonTitle: "OK",
        popupButtonFunction: () => {
          window.location.reload();
          setPopup({ popupState: false });
        },
      });
    } else if (type === "no_permission_delete") {
      setPopup({
        popupState: true,
        popupType: "warning",
        popupTitle: "You don't have permission to delete site",
        popupCancel: false,
        popupButton: true,
        popupButtonTitle: "OK",
        popupButtonFunction: () => {
          setPopup({ popupState: false });
        },
      });
    } else if (type === "toggle_staging_on") {
      setPopup({
        popupState: true,
        popupType: "warning",
        popupTitle: "Enable Staging?",
        popupSubtitle:
          "Do you want to turn on the staging environment for this site?",
        popupCancel: true,
        popupButton: true,
        popupButtonTitle: "Yes",
        popupCancelTitle: "No",
        popupCancelFunction: () => {
          setPopup({ popupState: false });
        },
        popupButtonFunction: () => {
          handleCreateStagingEnv();
          setPopup({ popupState: false });
        },
      });
    } else if (type === "toggle_staging_off") {
      setPopup({
        popupState: true,
        popupType: "warning",
        popupTitle: "Disable Staging?",
        popupSubtitle:
          "Do you want to turn off the staging environment for this site?",
        popupCancel: true,
        popupButton: true,
        popupButtonTitle: "Yes",
        popupCancelTitle: "No",
        popupCancelFunction: () => {
          setPopup({ popupState: false });
        },
        popupButtonFunction: () => {
          handleDeleteStaging();
          setPopup({ popupState: false });
        },
      });
    } else if (type === "error-hours") {
      setPopup({
        popupState: true,
        popupType: "error",
        popupTitle: "Staging Hours Limit Reached",
        popupSubtitle:
          "You do not have active hours remaining for your staging plan. Please upgrade your plan to continue.",
        popupCancel: false,
        popupButton: true,
        popupButtonTitle: "OK",
        popupButtonFunction: () => {
          setPopup({ popupState: false });
        },
      });
    } else if (type === "error-plan") {
      setPopup({
        popupState: true,
        popupType: "error",
        popupTitle: "Buy the Plan",
        popupSubtitle:
          "You do not have an active base plan. Please subscribe to a base plan to continue.",
        popupCancel: false,
        popupButton: true,
        popupButtonTitle: "OK",
        popupButtonFunction: () => {
          setPopup({ popupState: false });
        },
      });
    } else if (type === "none") {
      setPopup({ popupState: false });
    }
  };

  useEffect(() => {
    const myTimeout = setTimeout(() => {
      if (isInput?.tempdomainnamedev?.length >= 3) {
        let currenttempdomainnamedev = isInput?.tempdomainnamedev;
        const tempdomainnamedevElement = document.getElementById(
          "createsiteform-tempdomainnamedev",
        );
        if (tempdomainnamedevElement) {
          getStore().dispatch({
            type: Actions.API_IS_VALID_SITE,
            siteName: isInput.tempdomainnamedev,
            isDedicated: dedicatedHosting,
            meta: {
              onSuccess: () => {
                if (
                  currenttempdomainnamedev === tempdomainnamedevElement.value
                ) {
                  setIsInput({
                    ...isInput,
                    tempdomainnamedeverror: false,
                    tempdomainnamedev: isInput.tempdomainnamedev.toLowerCase(),
                  });
                }
              },
              onError: () => {
                if (
                  currenttempdomainnamedev === tempdomainnamedevElement.value
                ) {
                  setIsInput({
                    ...isInput,
                    tempdomainnamedeverror: true,
                    tempdomainnamedev: isInput.tempdomainnamedev.toLowerCase(),
                  });
                }
              },
            },
          });
        }
      }
    }, 500);
    return () => {
      clearTimeout(myTimeout);
    };
  }, [isInput?.tempdomainnamedev]);

  const fromFieldUpdateEnv = (value, type) => {
    if (type === "Temporary Domain Name") {
      const startsWithNonDigit = /^[^0-9]/;
      if (value !== "" && !startsWithNonDigit.test(value)) {
        return;
      }
      value = value.toLowerCase().replace(/[^a-zA-Z0-9]/g, "");
      const maxLength = 25;
      if (value.length > maxLength) {
        value = value.substr(0, maxLength);
      }
      const regExForNumberNotInStart = /^[^0-9]/;
      if (value.length <= 3 && regExForNumberNotInStart.test(value)) {
        setIsInput({
          ...isInput,
          tempdomainnamedeverror: false,
          tempdomainnamedev: value,
        });
      } else {
        setIsInput({
          ...isInput,
          tempdomainnamedeverror: false,
          tempdomainnamedev: value,
        });
      }
    } else if (type === "WordPress Username") {
      value = value.toLowerCase().replace(/[^a-zA-Z0-9]/g, "");
      setIsInput({
        ...isInput,
        wordpressusernamedeverror: false,
        wordpressusernamedev: value,
      });
    } else if (type === "WordPress Password") {
      if (!verifyPassword(value)) {
        setIsInput({
          ...isInput,
          wordpresspassworddeverror: true,
          wordpresspassworddev: value,
        });
      } else {
        setIsInput({
          ...isInput,
          wordpresspassworddeverror: false,
          wordpressconfirmpassworddeverror: false,
          wordpresspassworddev: value,
        });
      }
    }
  };

  const isFormValid = () => {
    return (
      !isInput.tempdomainnamedeverror &&
      isInput.tempdomainnamedev?.length > minLength &&
      isInput.tempdomainnamedev?.length < maxLength &&
      isInput.wordpressusernamedev?.length > 0 &&
      !isInput.wordpressusernamedeverror &&
      isInput.wordpresspassworddev?.length > 0 &&
      !isInput.wordpresspassworddeverror &&
      !nameLoading &&
      nameValid
    );
  };

  // const normalizedValue = (usedCredits / limits) * 100;

  const flushStateVariables = () => {
    setLoading(false);
    setAddStaging(false);
    setIsInput({
      wordpresspassworddev: "",
      wordpresspassworddeverror: false,
      wordpressusernamedev: "",
      wordpressusernamedeverror: false,
      wordpressconfirmpassworddev: "",
      wordpressconfirmpassworddeverror: false,
      wordpresspassworderror: false,
      wordpresspasswordErrorMessage: "",
      waf: true,
    });
  };

  // useEffect(() => {
  //   if (normalizedValue === limits) {
  //     setIsExpired(true);
  //   }
  // }, []);

  useEffect(() => {
    const myTimeout = setTimeout(() => {
      if (isInput?.tempdomainnamedev?.length >= 3) {
        let currentSiteName = isInput?.tempdomainnamedev;
        const sitenameElement = document.getElementById(
          "createsiteform-tempdomainnamedev",
        );
        if (sitenameElement) {
          // Set nameLoading to true before starting the API call
          setNameLoading(true);
          getStore().dispatch({
            type: Actions.API_IS_VALID_SITE,
            siteName: isInput.tempdomainnamedev,
            isDedicated: dedicatedHosting,
            meta: {
              onSuccess: () => {
                // Stop nameLoading after API success
                setNameLoading(false);
                setNameValid(true);
                if (currentSiteName === sitenameElement.value) {
                  setIsInput({
                    ...isInput,
                    tempdomainnamedeverror: false,
                    tempdomainnamedev: isInput.tempdomainnamedev.toLowerCase(),
                  });
                }
              },
              onError: () => {
                // Stop nameLoading after API error
                setNameLoading(false);
                setNameValid(false);
                if (currentSiteName === sitenameElement.value) {
                  setIsInput({
                    ...isInput,
                    tempdomainnamedeverror: false,
                    tempdomainnamedev: isInput.tempdomainnamedev.toLowerCase(),
                  });
                }
              },
            },
          });
        }
      }
    }, 500);
    return () => {
      clearTimeout(myTimeout);
    };
  }, [isInput?.tempdomainnamedev]);

  const handleCreateStagingEnv = () => {
    setLoading(true);
    getStore().dispatch({
      type: Actions.API_CREATE_STAGING,
      data: {
        siteId: siteId,
        stagingDomainType: "STAGING",
        prodToDev: stageType === "clone-prod" ? "true" : "false",
        wpUserId:
          isInput.wordpressusernamedev + "_" + isInput.tempdomainnamedev,
        domainName: isInput.tempdomainnamedev,
        sourceDomainName: `${name}`,
        wpPassword: isInput.wordpresspassworddev,
        orgId: orgId,
      },
      meta: {
        onSuccess: () => {
          getStore().dispatch({
            type: Actions.API_STAGING_DOMAIN_LIST,
            data: {
              siteId: siteId,
              toggle: true,
            },
            meta: {
              onSuccess: () => {
                setLoading(false);
                setIsToggle(true);
              },
              onError: () => {
                setLoading(false);
                setIsToggle(true);
              },
            },
          });
          getStore().dispatch({ type: Actions.API_GET_USER_NOTIFICATIONS });
          flushStateVariables();
          ActivatePopup("staging-created");
        },
        onError: (response) => {
          let data = response.data.response.data.errorMessage.includes(
            "active hours for staging plan",
          );
          let planData = response.data.response.data.errorMessage.includes(
            "have an active base plan",
          );
          if (data) {
            ActivatePopup("error-hours");
          } else if (planData) {
            ActivatePopup("error-plan");
          } else {
            ActivatePopup("error");
          }
          flushStateVariables();
        },
      },
    });
  };

  const handleDeleteStaging = () => {
    setLoading(true);

    getStore().dispatch({
      type: Actions.API_DELETE_STAGING,
      data: {
        stagingDomainName: development.domainName,
      },
      meta: {
        onSuccess: () => {
          getStore().dispatch({
            type: Actions.API_STAGING_DOMAIN_LIST,
            data: {
              siteId: siteId,
              toggle: false,
            },
            meta: {
              onSuccess: () => {
                setLoading(false);
                setIsToggle(false);
              },
              onError: () => {
                setLoading(false);
                setIsToggle(false);
              },
            },
          });
          getStore().dispatch({ type: Actions.API_GET_USER_NOTIFICATIONS });
          setLoading(false);
          setIsStaging(false);
          ActivatePopup("success-del-staging");
        },
        onError: () => {
          setLoading(false);
          ActivatePopup("error");
        },
      },
    });
  };

  const handlePayment = (paymentType) => {
    setLoading(true);
    const actionType =
      paymentType === "stripe"
        ? Actions.API_PAY_STAGING_STRIPE
        : Actions.API_PAY_STAGING_CASHFREE;

    getStore().dispatch({
      type: actionType,
      data: {
        orgId: organizationId,
        quantity: quantity,
        priceId: priceId,
      },
      meta: {
        onSuccess: (data) => {
          setLoading(false);
          setIsStaging(false);
          setQuantity(0);

          const cleanedData = data.replace(/\\/g, "");

          window.open(cleanedData, "_blank");
        },
        onError: () => {
          setLoading(false);
          setIsStaging(false);
          setQuantity(0);
          ActivatePopup("error");
        },
      },
    });
  };

  const handlePayStripeStaging = () => handlePayment("stripe");
  const handlePayCashfreeStaging = () => handlePayment("cashfree");

  const handleToggle = () => {
    if (status !== "PROVISIONING") {
      ActivatePopup("toggle_staging_off");
    }
  };

  const phpAdminOrWpAdmin = (portal) => {
    getStore().dispatch({
      type: Actions.API_AUTO_LOGIN,
      data: {
        portal: portal,
        stagingDomainId: selectedDomain.id,
      },
      meta: {
        onSuccess: (response) => {
          if (response) {
            window.open(response, "_blank");
          }
        },
        onError: (error) => {
          console.error("Auto login failed:", error);
        },
      },
    });
  };

  const isDisabled = () => {
    if (quantity === 0 || !isChecked) {
      return true;
    } else return false;
  };

  return (
    <>
      <Grid2
        className={styles.HeaderCardContainer}
        style={{
          border: `1.5px solid ${getBorderColor()}`,
          background: `${getBackgroundColor()}`,
        }}
      >
        <Grid2 className={styles.ImgText}>
          <Grid2>
            {selectedDomain?.environment === "STAGING" ? (
              ""
            ) : (
              <Grid2 className={styles.editIcon}>
                <EditOutlinedIcon
                  onClick={() => {
                    setPopupCard("edit");
                  }}
                  className={styles.EditIconColor}
                />
              </Grid2>
            )}

            {image ? (
              <img src={image} className={styles.uploadedImage} />
            ) : (
              <BlueprintSite className={styles.image} />
            )}
          </Grid2>

          <Grid2 className={styles.emailFlexBox}>
            <Grid2>
              <Grid2 className={styles.nameContainer}>
                <Grid2 className={styles.siteName}>{name}</Grid2>
                {getSiteStatus() === "Available" ? (
                  <Grid2 className={styles.activeStatus}>Available</Grid2>
                ) : (
                  <Grid2 className={styles.siteDown}>Site Down</Grid2>
                )}
                <Grid2 container spacing={1}>
                  {dedicatedHosting
                    ? ""
                    : addOnPerformanceSite.length > 0 && (
                        <Grid2 item>
                          <AddonIcons
                            icon={PerformanceIcon}
                            tooltipText="Performance Site"
                          />
                        </Grid2>
                      )}
                  {addOnWaf && (
                    <Grid2 item>
                      <AddonIcons icon={WafIcon} tooltipText="WAF" />
                    </Grid2>
                  )}
                </Grid2>
              </Grid2>
              <Grid2 className={styles.siteEmail} onClick={domainClick}>
                {domain}
              </Grid2>
            </Grid2>
            <Grid2 className={styles.adminFlexBox}>
              {!dedicatedHosting && (
                <>
                  <Grid2 className={styles.adminFlexBox1}>
                    <PhpOutlinedIcon className={styles.iconColor} />
                    <Grid2
                      className={styles.admin}
                      onClick={() => phpAdminOrWpAdmin("php_my_admin")}
                    >
                      PHP Admin
                    </Grid2>
                  </Grid2>
                  <Grid2 className={styles.adminFlexBox1}>
                    <WordPress className={styles.iconColor} />
                    <Grid2
                      className={styles.admin}
                      onClick={() => phpAdminOrWpAdmin("wp_admin")}
                    >
                      WP Admin
                    </Grid2>
                  </Grid2>
                </>
              )}
            </Grid2>
          </Grid2>
        </Grid2>
        <Grid2 className={styles.EnvAndIcon}>
          <Grid2 className={styles.envContainer}>
            {dedicatedHosting && (
              <CredentialsDropdown
                title="WP Admin Login Details"
                username={isDedicated?.wpUserName}
                password={instancePw}
                siteName={siteName}
              />
            )}

            {!dedicatedHosting && (
              <>
                {!ebsSite && (
                <Environment
                  Icon={CodeIcon}
                  label="Staging Environment"
                  flexDirection="row"
                  credit={usedCredits}
                  maxCredit={
                    stagingCredits > 0
                      ? stagingCredits + parseInt(limits)
                      : limits
                  }
                  buyStaging={() => {
                    handleStaging();
                  }}
                  handleToggle={() => {
                    handleToggle();
                  }}
                  staging={development ? true : false}
                  toggleStatus={isToggle}
                  setAddStaging={() => {
                    handleAddStaging();
                  }}
                  selectedDomain={() => handleEnvClick("Production", "STAGING")}
                  color={selectedDomain?.environment === "STAGING"}
                  stagingStatus={status}
                  location={location}
                  navigate={navigate}
                  orgId={orgId}
                  siteId={siteId}
                  isLoading={isLoading}
                  setIsLoading={setIsLoading}
                />
                )}

                <EnvironmentBox
                  Icon={Production}
                  label="Production"
                  shortLabel="Prod"
                  color={selectedDomain?.environment === "LIVE"}
                  onClick={() => handleEnvClick("Production", "LIVE")}
                  border="0px 8px 0px 0px"
                />
              </>
            )}
          </Grid2>
          <Grid2 className={styles.iconBoxFlexBox}>
            {selectedDomain?.environment === "LIVE" || dedicatedHosting ? (
              <>
                {/* blueprints and clones copy v1 (EFS) storage and only build v1 sites;
                    dedicated hosting has its own clone/blueprint path */}
                {!isSingleSite &&
                  (dedicatedHosting || (!ebsSite && buildsV1Sites(orgId))) && (
                  <>
                    <IconButton
                      icon={DrawIcon}
                      tooltipText="Blueprint"
                      onClick={() => {
                        navigate(
                          `/account/${orgId}/blueprints?createBlueprintSiteId=${siteId}`,
                        );
                      }}
                    />
                    <IconButton
                      icon={BluePrint}
                      tooltipText="Clone Site"
                      onClick={handleCloneSiteClick}
                    />
                  </>
                )}
                <IconButton
                  icon={Delete}
                  tooltipText="Delete"
                  onClick={() => {
                    if (parseInt(orgId) !== -1) {
                      if (
                        getRoleInOrg(emailId, orgInfo) === "Owner" ||
                        getRoleInOrg(emailId, orgInfo) === "Admin" ||
                        getRoleInOrg(emailId, orgInfo) === "Super Admin"
                      )
                        ActivatePopup("delete");
                      else ActivatePopup("no_permission_delete");
                    } else ActivatePopup("delete");
                  }}
                />
              </>
            ) : (
              <>
                <IconButton
                  icon={Delete}
                  tooltipText="Delete"
                  onClick={() => {
                    ActivatePopup("delete-staging");
                  }}
                />
              </>
            )}

            {/* <IconButton icon={Transfer} tooltipText="Transfer" /> */}
          </Grid2>
        </Grid2>
      </Grid2>

      <EditSiteImage
        popupCard={popupCard}
        image={image}
        setPopupCard={setPopupCard}
        loading={loading}
        siteName={name}
        setLoading={setLoading}
        siteId={siteId}
      />

      <NewPopup
        trigger={addStaging}
        header={"Add Staging Environment"}
        customWidth={"35%"}
        closePopup={() => {
          flushStateVariables();
        }}
        backPopup={"Close"}
        backOnClick={() => {
          setAddStaging(false);
          flushStateVariables();
        }}
        nextpopup={
          loading ? <CircularProgress size={20} color="inherit" /> : "Create"
        }
        nextOnClick={() => {
          if (isFormValid() && !submit) {
            setSubmit(true);
            handleCreateStagingEnv();
          }
        }}
        disabled={!isFormValid()}
      >
        <Grid2>
          <Grid2 className={styles.radioFont}>
            <Grid2
              className={`${styles.selectEnv} ${
                stageType === "clone-prod" ? styles.selected : ""
              }`}
              onClick={() => setIsStageType("clone-prod")}
            >
              <Grid2>
                <Grid2 className={styles.sliderLabel}>
                  Start with an existing environment
                </Grid2>
                <Grid2 className={styles.subTxt}>
                  I want to copy production environment to my staging.
                </Grid2>
              </Grid2>
              {stageType === "clone-prod" && (
                <Grid2 className={styles.tickBox}>
                  <CheckOutlinedIcon className={styles.Check} />
                </Grid2>
              )}
            </Grid2>
            <Grid2
              className={`${styles.selectEnv} ${
                stageType === "new-staging" ? styles.selected : ""
              }`}
              onClick={() => setIsStageType("new-staging")}
            >
              <Grid2>
                <Grid2 className={styles.sliderLabel}>
                  Start with a new environment
                </Grid2>
                <Grid2 className={styles.subTxt}>
                  I want to create an empty environment.
                </Grid2>
              </Grid2>
              {stageType === "new-staging" && (
                <Grid2 className={styles.tickBox}>
                  <CheckOutlinedIcon className={styles.Check} />
                </Grid2>
              )}
            </Grid2>
          </Grid2>
          <Grid2 className={styles.AdminWidth}>
            <CustomInput
              id="createsiteform-tempdomainnamedev"
              title={"Temporary Domain Name"}
              placeholder={"Enter Temporary Domain Name"}
              value={isInput?.tempdomainnamedev}
              setValue={(e, name) => {
                fromFieldUpdateEnv(e, name);
              }}
              suffix={
                nameLoading ? (
                  <CircularProgress size={20} />
                ) : nameValid ? (
                  isInput.tempdomainsuffix
                ) : !nameValid ? (
                  <HighlightOffIcon style={{ color: "red" }} />
                ) : null
              }
              error={
                isInput?.tempdomainnamedeverror ||
                (isInput?.tempdomainnamedev?.length > 0 &&
                  isInput?.tempdomainnamedev?.length <= minLength) ||
                isInput?.tempdomainnamedev?.length >= maxLength
              }
              errorMessage={
                isInput?.tempdomainnamedev?.length > 0 &&
                isInput?.tempdomainnamedev?.length <= minLength
                  ? "Temporary domain name must be above " +
                    minLength +
                    " characters"
                  : isInput?.tempdomainnamedev?.length >= maxLength
                    ? "Temporary domain name should not exceed 24 letters"
                    : isInput?.tempdomainnamedeverror
                      ? isInput?.tempdomainnamedevErrorMessage
                      : ""
              }
            />
          </Grid2>
          <Grid2 className={styles.AdminWidth}>
            <CustomInput
              title="WordPress Username"
              placeholder="Enter WordPress Username"
              value={isInput?.wordpressusernamedev}
              setValue={(e, name) => {
                fromFieldUpdateEnv(e, name);
              }}
              suffix={
                isInput?.tempdomainnamedev?.length > 0
                  ? "_" + isInput?.tempdomainnamedev
                  : ""
              }
              error={isInput?.wordpressusernamedeverror}
            />
          </Grid2>
          <Grid2 className={styles.AdminWidth}>
            <CustomInput
              title="WordPress Password"
              placeholder="Enter WordPress Password"
              value={isInput?.wordpresspassworddev}
              setValue={(e, name) => {
                fromFieldUpdateEnv(e, name);
              }}
              password={true}
              passwordview={true}
              error={isInput?.wordpresspassworddeverror}
              errorMessage={
                !verifyPassword(isInput?.wordpresspassworddev)
                  ? isInput?.wordpresspasswordErrorMessage
                  : null
              }
            />
          </Grid2>
        </Grid2>
      </NewPopup>

      <NewPopup
        trigger={isStaging}
        header={"Add Staging Environment"}
        backPopup={"Close"}
        backOnClick={() => {
          setIsStaging(false);
          setIsChecked(false);
        }}
        nextpopup={"Pay Now"}
        nextOnClick={
          selectedCountry === "India"
            ? handlePayCashfreeStaging
            : handlePayStripeStaging
        }
        disabled={isDisabled()}
        loading={loading}
      >
        <BuyStaging
          country={selectedCountry}
          quantity={quantity}
          setQuantity={setQuantity}
          userDetails={userDetails}
          isChecked={isChecked}
          setIsChecked={setIsChecked}
        />
      </NewPopup>

      <section>
        <FormPopup
          trigger={popup.popupState}
          setTrigger={setPopup}
          type={popup.popupType}
          title={popup.popupTitle}
          subtitle={popup.popupSubtitle}
          button={popup.popupButton}
          cancel={popup.popupCancel}
          buttonTitle={popup.popupButtonTitle}
          buttonFunction={popup.popupButtonFunction}
          loading={loading}
          cancelTitle={popup.popupCancelTitle}
          cancelFunction={popup.popupCancelFunction}
        />
      </section>
    </>
  );
}
